//websocketService.js
import { writable } from 'svelte/store';

const textStreamStores = {};
const cleanupTimers = {};
let subscriptions = {};


function setupCleanupTimer(streamId) {
    if (cleanupTimers[streamId]) {
        clearTimeout(cleanupTimers[streamId]);
    }
    
    cleanupTimers[streamId] = setTimeout(() => {
        delete textStreamStores[streamId];
        delete cleanupTimers[streamId];
    }, 300000); // 5 minutes
}

export function getTextStreamStore(streamId) {
    if (!textStreamStores[streamId]) {
        textStreamStores[streamId] = writable([]);
        console.log(`New store created for streamId: ${streamId}`);
        setupCleanupTimer(streamId);
    } else {
        console.log(`Existing store retrieved for streamId: ${streamId}`);
        setupCleanupTimer(streamId);
    }
    
    /*// Only subscribe if we haven't already subscribed to this streamId
    if (!subscriptions[streamId]) {
        subscriptions[streamId] = textStreamStores[streamId].subscribe(value => {
            //console.log(`Store contents for ${streamId}:`, value);
        });
    }*/


    return textStreamStores[streamId];
}


export function clearTextStreamStore(streamId) {
    if (cleanupTimers[streamId]) {
        clearTimeout(cleanupTimers[streamId]);
        delete cleanupTimers[streamId];
    }
    if (textStreamStores[streamId]) {
        textStreamStores[streamId].set([]); // Clear the store's value
        delete textStreamStores[streamId];
    }
}
